import { createApp } from 'vue';
import App from './App.vue';
import LaunchManager, { FatalLaunchError } from './manager/LaunchManager';
import router from './router';
import { store } from './store';
import mitt from 'mitt';
import moment from 'moment';

// Launch manager handles getting local storage values setup
const launchManager = LaunchManager.getInstance();
launchManager.prepare().then(mountApp).catch((error) => {
    if (error instanceof FatalLaunchError) {
        // The fatal error message is already displayed - nothing else should load.
        console.log(`main.ts, Fatal error during LaunchManager.prepare(), not mounting. Error[${error}]`);
        return;
    }

    // Without this catch, any rejected request during boot (e.g. a 404) leaves the page
    // blank forever - the app never mounts and there's no feedback beyond a console error.
    console.log(`main.ts, Error during LaunchManager.prepare(), mounting anyway. Error[${error}]`);
    mountApp();
});

function mountApp(): void {
    const app = createApp(App)
        .use(store)
        .use(router);
    app.config.globalProperties.eventBus = mitt();
    app.config.globalProperties.$moment = moment;
    app.mount('#app');
}
